var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIcoSave = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 14,
    viewBox: "0 0 18 14",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "ico_save",
    d: "M601.1,331.912l-8.551,8.769a.852.852,0,0,1-1.225,0l-3.1-3.186a.854.854,0,0,0-1.228,0l-1.079,1.117a.88.88,0,0,0,0,1.223l5.407,5.556a.853.853,0,0,0,1.226,0l10.871-11.147a.881.881,0,0,0,0-1.23l-1.095-1.108A.852.852,0,0,0,601.1,331.912Z",
    transform: "translate(-585.666 -331.652)",
    fill: "#00AABE"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIcoSave);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/ico_save.d18b33462777419966d4e444bea7274c.svg";